module.exports = __webpack_public_path__ + "img/sunny.9edafab1.svg";